<template>
    <div class="createReservationTopArea">
        <div class="row mt-0">
            <div class="col-sm-9 font-weight-600 fs-largest">
                <span>{{this.reservation.product.name}}</span>
            </div>

            <div class="col-sm-3 font-weight-600 fs-largest text-right">
                <span v-if="this.reservation.sequencialNumber">#{{this.reservation.sequencialNumber}}</span>
            </div>
        </div>

        <div class="row mt-0">
            <div class="col-sm-3">
                <div class="bold dark fs-small">Location:</div>
                <div class="bold py-1">{{ location }}</div>
            </div>

            <div class="col-sm-3">
                <div class="bold dark fs-small">Departure:</div>
                <div class="bold py-1">{{ departure }}</div>
            </div>

            <div class="col-sm-3">
                <div class="bold dark fs-small">Duration:</div>
                <div class="bold py-1">{{ hourToDuration(this.reservation.event.duration) }}</div>
            </div>
            
            <div class="col-sm-3 resourceSelectorNewReservation">
                <div class="bold dark fs-small">Resource:</div>
                <v-select
                    :options="resourcesWithAvailability"
                    v-model="reservation.selectedResource"
                    :disabled="isResourceDropdownDisabled"
                    label="name"
                    :placeholder="resourcePlaceholder"
                    :class="{'notAllowed': isResourceDropdownDisabled}"
                ></v-select>
            </div>
        </div>
    </div>
</template>

<script>
    import { reservationsMixin } from '@/mixins/reservations'

    import extendedVSelect from '@/extends/vue-select'

    export default {
        data() {
            return {}
        },
        props: {
            reservation: {
                type: Object
            },
        },
        mixins: [
            reservationsMixin
        ],
        computed: {
            location() {
                return this.reservation.event.location;
            },
            resourceAndLocation() {
                let resourcesNames = [];

                for (let resource of this.reservation.event.eventResources) {
                    resourcesNames.push(resource.name);
                }

                let resourcesString = resourcesNames.join(', ');
                let location = null;

                if(this.reservation.event.location){
                    location = this.reservation.event.location;
                }

                return resourcesString + ((resourcesString != '' && location != null)? ' - ' : '') + ((location != null)? location : '')
            },
            departure() {
                return  moment(this.reservation.event.start).format('DD/MM/YYYY - HH:mm')
            },
            isResourceDropdownDisabled() {
                const resources = this.reservation.event.eventResources;
                
                return resources.length <= 1;
            },
            resourcePlaceholder() {
                const resources = this.reservation.event.eventResources;

                if (resources.length === 0) return "No Resource";
            },
        },
        components: {
            vSelect: extendedVSelect
        }
    }
</script>

<style lang="scss">
    .createReservationTopArea {
        .dropdown {
            .dropdown-toggle {
                height: 1.8125rem;

                .selected-tag {
                    height: 1.8125rem;
                    margin: 0;
                    line-height: 1.5625rem;
                }

                .open-indicator {
                    height: 1.0625rem;
                }
            }
        }
    }

    .resourceSelectorNewReservation .v-select .dropdown-toggle .vs__actions {
        top: 0.1875rem;
    }

    .resourceSelectorNewReservation .v-select .vs__selected-options input.form-control[disabled] {
        height: 1.69rem;
        line-height: 1.69rem;
    }
</style>



// WEBPACK FOOTER //
// TopArea.vue?6b4e087e